export const importance_ActionControl = "JEc";
export const getAddIns_Button_ActionControl = "KEc";
export const findTime_Button_ActionControl = "LEc";
export const attachFile_FlyoutButton_ActionControl = "MEc";
export const attachSig_FlyoutButton_ActionControl = "NEc";
export const sensitivity_FlyoutButton_ActionControl = "OEc";
export const highImportance_Button_ActionControl = "PEc";
export const clpLabelDropDownLearnMoreButtonText_ActionControl = "QEc";
export const accCheckerText = "REc";
export const emojiText = "SEc";
export const fluidText = "TEc";
export const tableText = "UEc";
export const inlineImageText = "VEc";
export const proofingOptionsText = "WEc";
export const saveDraftText = "XEc";
export const toggleFromText = "YEc";
export const toggleHideFromText = "ZEc";
export const showMessageOptionsText = "_Ec";
export const switchToPlainTextText = "$Ec";
export const switchToHTMLTextText = "aFc";
export const toggleDarkComposeText = "bFc";
export default {importance_ActionControl,getAddIns_Button_ActionControl,findTime_Button_ActionControl,attachFile_FlyoutButton_ActionControl,attachSig_FlyoutButton_ActionControl,sensitivity_FlyoutButton_ActionControl,highImportance_Button_ActionControl,clpLabelDropDownLearnMoreButtonText_ActionControl,accCheckerText,emojiText,fluidText,tableText,inlineImageText,proofingOptionsText,saveDraftText,toggleFromText,toggleHideFromText,showMessageOptionsText,switchToPlainTextText,switchToHTMLTextText,toggleDarkComposeText};